/* eslint-disable no-empty-function */
/* eslint-disable @typescript-eslint/no-explicit-any */
import { AxiosInstance } from "axios";
import { Result } from "../../../Shared/Protocol/protocol-result";
import { IOrderReplacementEntity, IOrdersReplacementListPayload, IOrdersReplacementListResponse, IPayloadOrderReplacement, IPayloadUpdateOrderReplacement } from "./orders-replacement.interface";
import { Environment } from "../../../Config/constants";

export class OrdersReplacementApiRemoteService {
  constructor(private service: AxiosInstance) {}
    
  public update = async ({ id, ...rest }: IPayloadUpdateOrderReplacement): Promise<Result<void>> => {
    try {
        await this.service.put(`/replacement-orders/${id}`, { ...rest});

      return Result.ok();
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public create = async (data: IPayloadOrderReplacement): Promise<Result<void>> => {
    try {
        await this.service.post(`/replacement-orders`, data);

      return Result.ok();
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public list = async ({ page, customerId, searchBy }: IOrdersReplacementListPayload): Promise<Result<IOrdersReplacementListResponse>> => {
    try {
        const response = await this.service.get(`/replacement-orders`, { 
          params: {
            offset: Number(Environment.OFFSET_REGISTERS),
            page,
            customerId,
            searchBy
          }
        });

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public show = async (replacementOrder: string): Promise<Result<IOrderReplacementEntity>> => {
    try {
        const response = await this.service.get(`/replacement-orders/${replacementOrder}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };

  public destroy = async (replacementOrder: string): Promise<Result<void>> => {
    try {
        const response = await this.service.delete(`/replacement-orders/${replacementOrder}`);

      return Result.ok(response.data);
    } catch (error: any) {
      return Result.fail(error?.response?.data ?? error);
    }
  };
}
